module.exports = ".index_page>img {\r\n  position: relative;\r\n  top: 14px;\r\n  right:17px;\r\n}\r\n\r\n.index_page {\r\n  margin: 0 auto;\r\n  width: 300px;\r\n  height:300px;\r\n  font-size:1.5em;\r\n  letter-spacing: 3px;\r\n  margin-top:200px;\r\n  text-align: center;\r\n  padding-top: -20px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/index_page.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/index_page.css
// module chunks = styles